import { merge, clone, isFunction, forIn, isString } from "lodash";

/**
 * GameClient is a mediator between UI and GameManager
 * It is a singletone.
 */

import GameManager from "../js/framework/GameManager";

var GameClient = new (function GameClient() {});

/**
 * GameManager object
 * @private
 */
var manager = null;

/**
 * duplicate of GameManager's state
 * @private
 */
var state = undefined;

/**
 * An initialization with given Game object and initial state.
 * A new GameManager object is created, `state` is set to `initialState`.
 * Events (onMove, onFinish) are handled with GameClient's function.
 * @param game - Game object
 * @param initialState - an object of initial state
 * @return GameManager object
 */
GameClient.init = function(game, initialState) {
  state = initialState;
  manager = new GameManager(game, initialState);
  manager.onMove(function(args) { state = args.r; });
  manager.onFinish(onFinish);
};

/**
 * A set of players given by the object of the form `{ subj: notify }`.
 * A key is a subject.
 * A value of the key `subj` is a 'notify' callback which is called when
 *   a player `subj` has to make a move.
 * @private
 */
var players = {};

/**
 * A set of callback functions.
 * Each callback is called when the game is finished.
 * @private
 */
var fin = [];

/**
 * A set of response handlers of the form `{ subj: callback }`.
 * `makeMove[subj]` is what `GameManager.register` returned when
 * `subj` was registered.
 * This object is filled while registeration.
 * @private
 */
var makeMove = {};

/**
 * Modify a player object by wrapping a notification to check whether
 *   a game is started and is not stopped.
 * @param playerObj - a player object (@see register)
 */
function checkStarted(playerObj) {
  return merge(clone(playerObj),
    {
      notify: function(form) {
        if(started) playerObj.notify(form);
      }
    });
}

GameClient.register = register;

/**
 * register a player
 * The only argument is playerObj which is an object consisting of:
 * - subj is a subject (a string)
 * - notify is a callback called when the subject makes his move,
 *     the only argument is a form
 * - onFinish is an optional callback called when the game is finished,
 *     the only argument is a terminal state
 * @param playerObj - an object with mandatory `subj` and `notify` values
 * @return undefined
 */
function register(playerObj) {
  players[playerObj.subj] = playerObj.notify;
  if(isFunction(playerObj.onFinish))
    fin.push(playerObj.onFinish);
  makeMove[playerObj.subj] = manager.register(checkStarted(playerObj));
};

/**
 * `reregisterPlayers()` iteratively calls `GameManager.register`
 *   with all the players in 'players' list.
 * This procedure is supposed to be called right after init()
 *   when new GameManager is set 
 * @private
 */
function reregisterPlayers() {
  forIn(players, function(notify, subj) {
    var newPlayerObj = checkStarted({ subj: subj, notify: notify });
    makeMove[subj] = manager.register(newPlayerObj);
  });
}

GameClient.makeMove = _makeMove;

/**
 * UI components can use this method to make a move
 * @public
 * @param subj - a subject
 * @param v - move option
 * @throw an exception when a subject is not supposed to make a move
 */
function _makeMove(subj, v) {
  if(subj === undefined || !makeMove[subj])
    throw "check arguments of GameClient.makeMove";
  if(started) makeMove[subj](v);
};

/**
 * onFinish event handler.
 * It is based on `fin` object.
 * @param state - a state the game has been finished with
 * @private
 * @static
 */
function onFinish(state) {
  fin.forEach(function(callback) { callback(state); });
}




var started = false;
  
GameClient.start = function() {
  prev_started = undefined;
  if(!started) {
    started = true;
    manager.start();
  } else {
    console.log("The game has already been started");
  }
};
  
var prev_started = undefined;
  
GameClient.stop = function() {
  prev_started = started;
  started = false;
}
  
GameClient.resume = function() {
  if(prev_started === undefined)
    console.warn("GameManager.stop has never called");
  if(prev_started) GameClient.start();
}



/* saveState(label) adds a checkpoint with given label to CheckpointControl db
 */
GameClient.saveState = function(label) {
  if(! isString(label)) throw "label is not a string";
  // CheckpointControl.putGameState(label, state);
};

/* loadState(label) jumps to a state that corresponds to a checkpoint
 *   with given label.
 * More precisely, loadState(label) withdraws a state by its label and
 *   replaces a manager with another one based on withdrawn state.
 * Note that all the players are reregistered automatically.
 */
GameClient.loadState = function(label) {
  if(! isString(label)) throw "label is not a string";
  // var st = CheckpointControl.getGameState(label);
  // if(!st) throw "no checkpoint " + label;
  // if(!manager) throw "manager undefined";
  // this.init(manager.game, st);
  reregisterPlayers();
  if(started) manager.start();
};



export default GameClient;
